var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_176",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_176",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAABW0lEQVR4nO3YMUoDQRjF8U8R7NTeI9h5AK0EO8HMi4Wl4CUE03gLC0Ex35gmnY1CQCyFQOZLisUDKIj2plhJaZNdIws7s+8Hc4A/8xZ2V4SIiOiX45tsDRpO4O3aeZvA2zvUps7bt/P26by9wYcMPjy1NBxKrHYHgxWonUPtC97yUkfDmcTooD/ccBoeSodGHZznS05D/8+xsQZD7XSh2BiDO5182Xl7bUwwuqO9hWOjDPZ20bDg8FgcZZet7nhr/z5bldi5wuc33EpKoOFjXnDbj3ckJVCbzr3h3nBTUoKC53f2uilNCpbUgMEW9w3jPy8VZc7dqC1NCm77ybY06oZ7L+tSJ6gwdvarR+oGVQarPUvdoNJJhytpVLDW8NMQ1QYfSWxQECWpAYONN5wUcNLGSScFnLRx0kkBJ22cdFLASRsnnRRw0sZJJwWctHHSSQEnbWlPmoiIZHE/6T9QG78W4h8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.523beac76efc8f345f5fe35e1f4a5b5b.svg";
export { ForwardRef as ReactComponent };